export default __webpack_public_path__ + "static/media/teams-icon.677ee8ee.svg";